import { createAction, createActionGroup, props } from "@ngrx/store";
import {FriendReaction, ReactionCount} from "./reactions.model";

export const ReactionsActions = createActionGroup({
  source: "Users",
  events: {
    "Found Reaction Count": props<{ reactionCount: ReactionCount }>(),
    "Found Reaction Counts": props<{ reactionCounts: ReactionCount[] }>(),
    "Found Friend Reaction": props<{ friendReaction: FriendReaction }>(),
    "Found Friend Reactions": props<{ friendReactions: FriendReaction[] }>(),
    "User Reacted": props<{ referenceId: string, referenceType: string, reactionString: string }>(),
  },
});
